import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=32275244&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=32275244&prod&lang=scss&scoped=true"
import style1 from "./Login.vue?vue&type=style&index=1&id=32275244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32275244",
  null
  
)

export default component.exports